module.exports = __webpack_public_path__ + "img/document_w.a12d82b6.svg";